import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, withKeys as _withKeys, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full" }
const _hoisted_2 = { class: "justify-start mr-auto" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-1" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col flex items-end space-x-4" }
const _hoisted_6 = { class: "flex flex-col justify-end" }
const _hoisted_7 = { class: "mt-5" }
const _hoisted_8 = { class: "card-body pt-0" }

import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import Calendar from 'primevue/calendar';
import AutoComplete from "primevue/autocomplete";
import { ref, onMounted, watch } from "vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { downloadSoldDocumentCsv, fetchDocumentsAvailable } from "@/_services/document/document";
import { deleteDocument } from "@/_services/document/document";
import { Document } from "@/models/product/document/Document";
import swal from "@/_helpers/swal";
import ApiService from "@/_services/api.service";
import moment from "moment/moment";

const localStorageKey = "selectedDocuments";
const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'StockAvailableList',
  setup(__props) {

const isLoading = ref<boolean>(true);
const documents = Array<Document>();
const tableData = ref<Array<Document>>(documents);
const selectedDocuments = ref(Array<Document>());
const availabilityStartDate = ref<string>('');
const availabilityEndDate = ref<string>('');
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const currentPage = ref<number>(0);
const docNameModel = ref<string>("");
let supplierModel = ref<string | null>(null);
let productNameModel = ref<string>("");

onMounted(async () => {
    await populateDatatable();
    setLocalStorageRowsPerPage(rows.value);
});

async function populateDatatable() {
    let paramsFilter: any = {
        name: docNameModel.value,
        supplier: supplierModel.value,
        productName: productNameModel.value,
        availabilityStartDate: availabilityStartDate.value,
        availabilityEndDate: availabilityEndDate.value,
    }
    const [loadingDt,totalRecordsDt,  tableDataDt] = await fetchDocumentsAvailable(rows.value, page.value, paramsFilter);
    isLoading.value = loadingDt;
    tableData.value = tableDataDt;
    totalRecords.value = totalRecordsDt;
}

watch([availabilityStartDate, availabilityEndDate],
    ([newAvailabilityStartDate, newAvailabilityEndDate], [prevAvailabilityStartDate, prevAvailabilityEndDate]) => {
        if (
            (newAvailabilityStartDate === '' || newAvailabilityStartDate === undefined) &&
            (newAvailabilityEndDate === '' || newAvailabilityEndDate === undefined) &&
            productNameModel.value === '' &&
            docNameModel.value === ''
        ) {
            clearDtSelectedDocuments();
        }
    }
);

watch(supplierModel, () => {
    onChangeSelectedSupplier();
});

const onChangeSelectedSupplier = async (): Promise<void> => {
    await populateDatatable();
};

const checkDatesIntervalRules = (node: any) => {
    const selectedDate = node.value;
    if (typeof availabilityStartDate.value !== 'undefined' && typeof availabilityEndDate.value !== 'undefined') {
        return moment(availabilityStartDate.value).isSameOrBefore(availabilityEndDate.value);
    }

    return true;
}

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable();
};
const onFilterDt = () => {
    if (docNameModel.value === ''
        && productNameModel.value === ''
        && isAvailabilityStartDateEmpty()
        && isAvailabilityEndDateEmpty()
    ) {
        clearDtSelectedDocuments();
    }

    rows.value = 10;
    page.value = 1;
    populateDatatable();
};

const filters = ref({
    //global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    docName: { value: null, matchMode: FilterMatchMode.IN },
    productName: { value: null, matchMode: FilterMatchMode.IN },
    supplierName: { value: null, matchMode: FilterMatchMode.IN },
    expirationDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
});

function getLocalStorageRowsPerPage() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.rows) {
        return localStorageData.rows;
    }
    return defaultRowsPerPage;
}

function getLocalStorageData() {
    let storageData = localStorage.getItem(localStorageKey);
    if (null !== storageData && "undefined" !== storageData) {
        return JSON.parse(storageData);
    }

    return null;
}

function setLocalStorageRowsPerPage(rowPerPage: number) {
    let storageData = localStorage.getItem(localStorageKey);
    if (null !== storageData) {
        let localStorageObject = JSON.parse(storageData);
        localStorageObject.rows = rowPerPage;
        localStorage.setItem(localStorageKey, JSON.stringify(localStorageObject));
    }
}

function disableGroupAction(selectedDocuments){
    selectedDocuments.length.value <= 0
        ? swal.warning("Veuillez selectionner au moins un document")
        : swal
            .confirm(`Êtes-vous sûr de vouloir désactiver  les (${selectedDocuments.length}) Document(s) ?`)
            .then((result) => {
                if (result.isConfirmed) {
                    disableGroupDocuments(selectedDocuments);
                }else {
                    window.location.reload();
                }
            });
}
async function disableGroupDocuments(selectedDocuments) {
    const uuidArray = getSelectedDocumentUuids(selectedDocuments);


    const dataToSendToApi = {
        documents: uuidArray,
    };

    await ApiService.patchWithoutSlug("disable_product_documents", dataToSendToApi)
        .then(() => {
            swal.info(`Vous venez de désactiver (${selectedDocuments.length}) document(s).`).then(() => {
                window.location.reload();
            });
        })
        .catch(() => {
            swal.error().then(() => {
                window.location.reload();
            });
        });
}

function getSelectedDocumentUuids(selectedDocuments) {
    return selectedDocuments.map((document) => document.uuid);
}

async function searchSuppliers_old({search}) {
    if (!search) return [];
    const fetchSuppliers = await ApiService.get(`suppliers?name=${search || ''}&isActive=true`);
    return fetchSuppliers.data.data.map((val: any) => {
        return {
            label: val.name,
            value: val.uuid
        }
    });
}

async function searchSuppliers({ search, page, hasNextPage }) {
    interface IParams { itemsPerPage: number; page: number; name?: string }
    const params: IParams = {
        itemsPerPage: 5,
        page: page,
        ...(search && { name: search.trim() })
    };

    const { data } = await ApiService.get(`suppliers?isActive=true`, {
        headers: { Accept: 'application/ld+json' },
        params: params,
    });

    const totalSuppliersForDropDown = data.data['hydra:totalItems'];
    const suppliers = data.data['hydra:member'].map((item: {uuid: string, name: string}) => ({
        label: item.name,
        value: item.uuid,
    }));

    const hasItems = suppliers.length > 0;
    if (hasItems && page !== totalSuppliersForDropDown) {
        hasNextPage();
    }

    return suppliers;
}

const filterAvailableDocumentsByExpirationDate = async () => {
    isLoading.value = true;
    try {
        await populateDatatable();
    } catch (error) {
        swal.error("Erreur lors de la recherche par date d'expiration");
    } finally {
        isLoading.value = false;
    }
}

const clearDtSelectedDocuments = () => {
    selectedDocuments.value = [];
};

const isAvailabilityStartDateEmpty = (): boolean => {
    return availabilityStartDate.value === "" || availabilityStartDate.value === undefined;
}

const isAvailabilityEndDateEmpty = (): boolean => {
    return availabilityEndDate.value === "" || availabilityEndDate.value === undefined;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_unref(DataTable), {
    filters: filters.value,
    "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => ((filters).value = $event)),
    value: tableData.value,
    rows: rows.value,
    paginator: true,
    loading: isLoading.value,
    filterDisplay: "row",
    rowsPerPageOptions: rowsPerPageOptions,
    selection: selectedDocuments.value,
    "onUpdate:selection": _cache[7] || (_cache[7] = ($event: any) => ((selectedDocuments).value = $event)),
    lazy: "",
    onPage: onPaginate,
    currentPage: currentPage.value,
    totalRecords: totalRecords.value
  }, {
    header: _withCtx(() => [
      _createVNode(_component_FormKit, {
        type: "form",
        actions: false
      }, {
        default: _withCtx(({ state: { valid } }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_FormKit, {
                    type: "datepicker",
                    name: "availabilityStartDate",
                    label: "Date de début",
                    validation: "checkDatesIntervalRules",
                    "validation-rules": { checkDatesIntervalRules: checkDatesIntervalRules },
                    "validation-messages": {
                    checkDatesIntervalRules: 'La date de début doit être inférieur ou égale à la date de fin.',
                  },
                    "validation-visibility": "live",
                    format: "DD/MM/YYYY",
                    "value-format": "YYYY-MM-DD",
                    modelValue: availabilityStartDate.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((availabilityStartDate).value = $event)),
                    clearable: "",
                    placeholder: "Sélectionner une date de début",
                    "label-class": 'text-lg font-bold text-gray-950'
                  }, null, 8, ["validation-rules", "validation-messages", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_FormKit, {
                    type: "datepicker",
                    name: "availabilityEndDate",
                    label: "Date de fin",
                    validation: "checkDatesIntervalRules",
                    "validation-rules": { checkDatesIntervalRules: checkDatesIntervalRules },
                    "validation-messages": {
                        checkDatesIntervalRules: 'La date de fin doit être supérieure ou égale à la date de début.',
                      },
                    "validation-visibility": "live",
                    format: "DD/MM/YYYY",
                    "value-format": "YYYY-MM-DD",
                    modelValue: availabilityEndDate.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((availabilityEndDate).value = $event)),
                    clearable: "",
                    "label-class": 'text-lg font-bold text-gray-950'
                  }, null, 8, ["validation-rules", "validation-messages", "modelValue"]),
                  _createVNode(_component_FormKit, {
                    type: "button",
                    label: "Filtrer",
                    class: _normalizeClass({ 'btn-secondary': true, 'btn-block': true }),
                    onClick: filterAvailableDocumentsByExpirationDate,
                    disabled: !valid || isLoading.value
                  }, null, 8, ["disabled"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(Button), {
                size: "small",
                class: "btn btn-primary p-2 ps-2 pe-2",
                style: {"margin-top":"0.5em"},
                title: "Désactiver la liste des Documents",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (disableGroupAction(selectedDocuments.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Désactiver la liste des Documents ")
                ]),
                _: 1
              }),
              _createElementVNode("p", _hoisted_7, "Nombre de ligne sélectionnée(s) : " + _toDisplayString(selectedDocuments.value.length) + " Document(s)", 1)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    empty: _withCtx(() => [
      _createTextVNode("Aucun résultat trouvé.")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(Column), { selectionMode: "multiple" }),
        _createVNode(_unref(Column), {
          field: "docName",
          header: "Nom du Document",
          showFilterMenu: false
        }, {
          filter: _withCtx(({ filterCallback }) => [
            _createVNode(_unref(InputText), {
              modelValue: docNameModel.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((docNameModel).value = $event)),
              type: "text",
              onInput: ($event: any) => (filterCallback()),
              class: "p-column-filter",
              placeholder: "Rechercher un document",
              onKeyup: _withKeys(onFilterDt, ["enter"])
            }, null, 8, ["modelValue", "onInput", "onKeyup"])
          ]),
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.docName), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "productName",
          header: "Nom du produit",
          showFilterMenu: false
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.productName), 1)
          ]),
          filter: _withCtx(({ filterCallback }) => [
            _createVNode(_unref(InputText), {
              modelValue: _unref(productNameModel),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(productNameModel) ? (productNameModel).value = $event : productNameModel = $event)),
              type: "text",
              onInput: ($event: any) => (filterCallback()),
              class: "p-column-filter",
              placeholder: "Rechercher par produit",
              onKeyup: _withKeys(onFilterDt, ["enter"])
            }, null, 8, ["modelValue", "onInput", "onKeyup"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "productType",
          header: "Type de produit"
        }),
        _createVNode(_unref(Column), {
          field: "supplierName",
          header: "Fournisseur",
          showFilterMenu: false
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.supplierName), 1)
          ]),
          filter: _withCtx(({ filterCallback }) => [
            _createVNode(_component_FormKit, {
              type: "taglist",
              name: "supplier",
              placeholder: "Sélectionner un fournisseur",
              modelValue: _unref(supplierModel),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(supplierModel) ? (supplierModel).value = $event : supplierModel = $event)),
              options: searchSuppliers,
              "empty-message": "Aucun fournisseur trouvé",
              max: "1"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "expirationDate",
          header: "Expiration",
          dataType: "date"
        })
      ])
    ]),
    _: 1
  }, 8, ["filters", "value", "rows", "loading", "selection", "currentPage", "totalRecords"]))
}
}

})